import { ProductShort } from "@models";

export class Company {
	id: number;
	debnr: string;
	crdnr: string;
	name: string;
	email: string;
	website: string;
	telephone: string;
	telephone2: string;
	fax: string;
	classification: string;
	classification_id: number;
	pricelist_id: number;
	pricelist: string;
	discount: number;
	status: number;
	billing_address: string;
	billing_zipcode: string;
	billing_city: string;
	billing_province_id: string;
	billing_country_id: string;
	delivery_address: string;
	delivery_zipcode: string;
	delivery_city: string;
	delivery_province_id: string;
	delivery_country_id: string;
	comments: string;
	user_created: string;
	user_modified: string;
	created_at: string;
    updated_at: string;
        
    products: ProductShort[];
    
	constructor() {
		this.id = 0;
	}
}



// WEBPACK FOOTER //
// /var/www/vhosts/vinologiwijnen.nl/httpdocs/crm/resources/assets/src/app/shared/models/crm/company.ts